import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with base config
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    throw error;
  }
);

// Authentication
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  changePassword: (email, currentPassword, newPassword) => 
    api.post('/auth/change-password', { email, current_password: currentPassword, new_password: newPassword }),
  resetPassword: (extensionId) => api.post(`/auth/reset-password/${extensionId}`),
  checkEmail: (email) => api.get(`/auth/check-email/${email}`),
};

// Dashboard
export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
  getActiveCalls: () => api.get('/dashboard/active-calls'),
  getSystemStatus: () => api.get('/dashboard/system-status'),
  getRecentEvents: () => api.get('/dashboard/recent-events'),
};

// Extensions
export const extensionsAPI = {
  list: () => api.get('/extensions'),
  get: (id) => api.get(`/extensions/${id}`),
  create: (data) => api.post('/extensions', data),
  update: (id, data) => api.put(`/extensions/${id}`, data),
  delete: (id) => api.delete(`/extensions/${id}`),
  updateStatus: (id, status) => api.put(`/extensions/${id}/status`, null, { params: { status } }),
};

// SIP Trunks
export const sipTrunksAPI = {
  list: () => api.get('/sip-trunks'),
  get: (id) => api.get(`/sip-trunks/${id}`),
  create: (data) => api.post('/sip-trunks', data),
  update: (id, data) => api.put(`/sip-trunks/${id}`, data),
  delete: (id) => api.delete(`/sip-trunks/${id}`),
  test: (id) => api.post(`/sip-trunks/${id}/test`),
  getTemplates: () => api.get('/sip-trunks/templates/providers'),
};

// Ring Groups
export const ringGroupsAPI = {
  list: () => api.get('/ring-groups'),
  get: (id) => api.get(`/ring-groups/${id}`),
  create: (data) => api.post('/ring-groups', data),
  update: (id, data) => api.put(`/ring-groups/${id}`, data),
  delete: (id) => api.delete(`/ring-groups/${id}`),
};

// Call Queues
export const callQueuesAPI = {
  list: () => api.get('/call-queues'),
  get: (id) => api.get(`/call-queues/${id}`),
  create: (data) => api.post('/call-queues', data),
  update: (id, data) => api.put(`/call-queues/${id}`, data),
  delete: (id) => api.delete(`/call-queues/${id}`),
};

// Outbound Rules
export const outboundRulesAPI = {
  list: () => api.get('/outbound-rules'),
  get: (id) => api.get(`/outbound-rules/${id}`),
  create: (data) => api.post('/outbound-rules', data),
  update: (id, data) => api.put(`/outbound-rules/${id}`, data),
  delete: (id) => api.delete(`/outbound-rules/${id}`),
};

// Office Hours
export const officeHoursAPI = {
  list: () => api.get('/office-hours'),
  get: (id) => api.get(`/office-hours/${id}`),
  create: (data) => api.post('/office-hours', data),
  update: (id, data) => api.put(`/office-hours/${id}`, data),
  delete: (id) => api.delete(`/office-hours/${id}`),
};

// Holidays
export const holidaysAPI = {
  list: () => api.get('/holidays'),
  create: (data) => api.post('/holidays', data),
  delete: (id) => api.delete(`/holidays/${id}`),
};

// Call Logs
export const callLogsAPI = {
  list: (params = {}) => api.get('/call-logs', { params }),
  get: (id) => api.get(`/call-logs/${id}`),
  getStats: () => api.get('/call-logs/stats'),
};

// Event Logs
export const eventLogsAPI = {
  list: (params = {}) => api.get('/event-logs', { params }),
  getStats: () => api.get('/event-logs/stats'),
  create: (data) => api.post('/event-logs', data),
};

// Settings
export const settingsAPI = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/settings', data),
};

export default api;
